import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=51ff60fb&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.vue?vue&type=style&index=0&lang=css&"
import style1 from "./slider.vue?vue&type=style&index=1&id=51ff60fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ff60fb",
  null
  
)

export default component.exports